import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,
    Label,
    Input,
    FormGroup
} from 'reactstrap';

import RGL, { WidthProvider } from "react-grid-layout";
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

import Isvg from 'react-inlinesvg';
import moveIcon from '../../../assets/svg/move.svg';
import moreIcon from '../../../assets/svg/more.svg';
import saveIcon from '../../../assets/svg/save-icon.svg';


import moment from 'moment';
import { API_ENDPOINT } from '../../../constants';
import CustomCalendarFilterSelect from '../customCalendarFilterSelect';
import ErrorModal from '../../../components/errorModal';
import DeleteModal from '../../../components/deleteModal';
import InfoModal from '../../../components/infoModal';
import DatePicker from '../../../components/forms/fields/datePicker';


function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}

class CustomFilterStatistics extends React.Component {

    constructor(props) {
        super(props);

        const tsNow = Math.floor(new Date().getTime() / 1000);
        this.state = {
            filter: {
                range: {
                    start: this.props.getStringDateTs(tsNow, 'MM/DD/YYYY'),
                    end: this.props.getStringDateTs(tsNow, 'MM/DD/YYYY')
                },
                groups: [],
                clinics: [],
                clinicians: []
            },
            clinics: [],
            groups: [],
            clinicians: []
        }
    }

    setInitialData = () => {
        this.getFiltersOptions();
    }

    getFiltersOptions = () => {
        const clinicId = this.props.selectedClinic;
        if (!clinicId) {
            return;
        }
        let setObj = {
            clinics: [],
            groups: [],
            clinicians: []
        }

        this.setState(setObj, () => {
            fetch(API_ENDPOINT + `/data/statistics/filters/${clinicId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(parseJSON).then(({ result, status }) => {
                if (result) {
                    let setResultObj = {};
                    setResultObj.clinics = result?.clinics || [];
                    setResultObj.groups = result?.groups || [];
                    setResultObj.clinicians = result?.clinicians || [];
                    this.setState(setResultObj, () => {
                        // let filter = this.state.filter;
                        // if (result?.clinics?.length) filter.clinics = result.clinics.map(item => item._id);
                        // if (result?.groups?.length) filter.groups = result.groups.map(item => item._id);
                        // if (result?.clinicians?.length) filter.clinicians = result.clinicians.map(item => item._id);
                        // this.setFilter(filter, () => {
                        //     if (this.setSelectedGroups) this.setSelectedGroups(filter.groups);
                        //     if (this.setSelectedClinics) this.setSelectedClinics(filter.clinics);
                        //     if (this.setSelectedClinicians) this.setSelectedClinicians(filter.clinicians);
                        // });

                    });
                }

            })
        });
    }


    componentDidMount() {
        this.setInitialData();

    }
    componentDidUpdate(prevProps, prevState) {

    }
    componentWillUnmount() {

    }
    setFilter = (filter, callback = null) => {
        this.setState({ filter }, () => {
            this.checkFilterRelations(callback);
        });
    };
    checkFilterRelations = (callback = null) => {
        let filter = this.state.filter;
        const { clinics, groups, clinicians } = this.state;
        let updateClinics = false, updateClinicians = false;
        if (filter?.clinics?.length > 0 && filter?.groups?.length > 0) {
            let clinicsIds = [];
            let selectedClinics = clinics.filter(item => filter.clinics.includes(item._id));
            for (let i = 0; i < selectedClinics.length; i++) {
                if (selectedClinics[i]?.groupId && filter?.groups?.includes(selectedClinics[i].groupId)) {
                    clinicsIds.push(selectedClinics[i]._id);
                } else {
                    updateClinics = true;
                }
            }
            if (updateClinics) {
                filter.clinics = clinicsIds;
            }
        }
        if (filter?.clinicians?.length > 0 && filter?.groups?.length > 0) {
            let cliniciansIds = [];
            let selectedClinicians = clinicians.filter(item => filter.clinicians.includes(item._id));
            for (let i = 0; i < selectedClinicians.length; i++) {
                let groupIds = selectedClinicians[i]?.groupIds || [];
                if (groupIds?.length) {
                    let check = true
                    for (let j = 0; j < groupIds.length; j++) {
                        if (filter?.groups?.includes(groupIds[j])) {
                            cliniciansIds.push(selectedClinicians[i]._id);
                            check = false;
                            break;
                        }
                    }
                    if (check) {
                        updateClinicians = true;
                    }
                } else {
                    updateClinicians = true;
                }
            }
            if (updateClinicians) {
                filter.clinicians = cliniciansIds;
            }
        }
        if (filter?.clinicians?.length > 0 && filter?.clinics?.length > 0) {
            let cliniciansIds = [];
            let selectedClinicians = clinicians.filter(item => filter.clinicians.includes(item._id));
            for (let i = 0; i < selectedClinicians.length; i++) {
                let clinicIds = selectedClinicians[i]?.clinicIds || [];
                if (clinicIds?.length) {
                    let check = true
                    for (let j = 0; j < clinicIds.length; j++) {
                        if (filter?.clinics?.includes(clinicIds[j])) {
                            cliniciansIds.push(selectedClinicians[i]._id);
                            check = false;
                            break;
                        }
                    }
                    if (check) {
                        updateClinicians = true;
                    }
                } else {
                    updateClinicians = true;
                }
            }
            if (updateClinicians) {
                filter.clinicians = cliniciansIds;
            }
        }
        if (updateClinics || updateClinicians) {
            this.setState({ filter }, () => {
                if (updateClinics && this.setSelectedClinics) {
                    this.setSelectedClinics(this.state.filter.clinics);
                }
                if (updateClinicians && this.setSelectedClinicians) {
                    this.setSelectedClinicians(this.state.filter.clinicians);
                }
                if (callback) callback();
                if (this.props.onChange) this.props.onChange(this.state.filter);
            });
        } else {
            if (callback) callback();
            if (this.props.onChange) this.props.onChange(this.state.filter);
        }


    }

    generateFiltersOptions = () => {
        const { clinics, groups, clinicians } = this.state;
        let response = {
            clinics: [],
            groups: [],
            clinicians: []
        }
        if (groups?.length) {
            response.groups = groups;
        }
        if (clinics?.length) {
            const selectedGroups = groups.filter(item => this.state.filter.groups.includes(item._id));
            if (selectedGroups?.length) {
                let clinicsIds = [];
                for (let i = 0; i < selectedGroups.length; i++) {
                    if (selectedGroups[i]?.clinics?.length) {
                        for (let j = 0; j < selectedGroups[i].clinics.length; j++) {
                            if (!clinicsIds.includes(selectedGroups[i].clinics[j])) {
                                clinicsIds.push(selectedGroups[i].clinics[j]);
                            }
                        }
                    }
                }
                response.clinics = clinics.filter(item => clinicsIds.includes(item._id));
            } else {
                response.clinics = clinics;
            }
        }

        if (clinicians?.length) {
            const selectedClinics = clinics.filter(item => this.state.filter.clinics.includes(item._id));
            const selectedGroups = groups.filter(item => this.state.filter.groups.includes(item._id));
            if (!selectedGroups?.length && !selectedClinics?.length) {
                response.clinicians = clinicians;
            } else {
                if (selectedGroups?.length) {
                    let cliniciansIds = [];
                    for (let i = 0; i < clinicians.length; i++) {
                        let groupIds = clinicians[i]?.groupIds || [];
                        if (groupIds?.length) {
                            for (let j = 0; j < groupIds.length; j++) {
                                if (this.state.filter.groups.includes(groupIds[j])) {
                                    if (!cliniciansIds.includes(clinicians[i]._id))
                                        cliniciansIds.push(clinicians[i]._id);
                                }
                            }
                        } else {
                            if (!cliniciansIds.includes(clinicians[i]._id))
                                cliniciansIds.push(clinicians[i]._id);
                        }
                    }
                    response.clinicians = clinicians.filter(item => cliniciansIds.includes(item._id));
                }
                if (selectedClinics?.length) {
                    let cliniciansIds = [];
                    for (let i = 0; i < clinicians.length; i++) {
                        let clinicIds = clinicians[i]?.clinicIds || [];
                        if (clinicIds?.length) {
                            for (let j = 0; j < clinicIds.length; j++) {
                                if (this.state.filter.clinics.includes(clinicIds[j])) {
                                    if (!cliniciansIds.includes(clinicians[i]._id))
                                        cliniciansIds.push(clinicians[i]._id);
                                }
                            }
                        } else {
                            if (!cliniciansIds.includes(clinicians[i]._id))
                                cliniciansIds.push(clinicians[i]._id);
                        }
                    }
                    response.clinicians = clinicians.filter(item => cliniciansIds.includes(item._id));
                }
            }
        }
        const _dateFrom = this.state._tempRange?.start ?? this.state.filter?.range?.start;
        if (_dateFrom) {
            response.dateFrom = this.formatStringDate(_dateFrom);
        }
        const _dateTo = this.state._tempRange?.end ?? this.state.filter?.range?.end;
        if (_dateTo) {
            response.dateTo = this.formatStringDate(_dateTo);
        }

        response.clinicians = [
            { _id: 'unassigned', name: 'Unassigned'.translate(this.props.lang) },
            ...response.clinicians
        ]
        return response;
    }
    formatStringDate = (date) => {
        const dateFormat = this.props.dateFormat;
        if (!date || !dateFormat) return date;
        let dateSplit = date.split('/');
        let mm = dateSplit[0];
        let dd = dateSplit[1];
        let yyyy = dateSplit[2];

        return dateFormat.replace('MM', mm).replace('DD', dd).replace('YYYY', yyyy);
    }
    inverseFormatStringDate = (date) => {
        const dateFormat = 'MM/DD/YYYY';
        if (!date || !dateFormat) return date;
        let dateSplit = date.split('-');
        let dateFormatSplit = this.props.dateFormat.split('-');
        let mm = dateSplit[dateFormatSplit.indexOf('MM')];
        let dd = dateSplit[dateFormatSplit.indexOf('DD')];
        let yyyy = dateSplit[dateFormatSplit.indexOf('YYYY')];
        return dateFormat.replace('MM', mm).replace('DD', dd).replace('YYYY', yyyy);
    }
    generateSelectionsText = (data) => {
        let response = {
            clinics: 'N/A'.translate(this.props.lang),
            departments: 'N/A'.translate(this.props.lang),
            clinicians: 'N/A'.translate(this.props.lang)
        }
        const { clinics, groups, clinicians } = data;
        const filter = this.state.filter;

        const selectedGroups = groups.filter(item => filter.groups.includes(item._id));
        const selectedClinics = clinics.filter(item => filter.clinics.includes(item._id));
        const selectedClinicians = clinicians.filter(item => filter.clinicians.includes(item._id));
        if (selectedGroups?.length) {
            response.clinics = selectedGroups.map(item => item.name).join(', ');
        }
        if (selectedClinics?.length) {
            const isAllSelected = selectedClinics?.length === clinics?.length;
            if (isAllSelected) {
                response.departments = 'All'.translate(this.props.lang);
            } else {
                response.departments = selectedClinics.map(item => item.name).join(', ');
            }
        }
        if (selectedClinicians?.length) {
            const isAllSelected = selectedClinicians?.length === clinicians?.length;
            if (isAllSelected) {
                response.clinicians = 'All'.translate(this.props.lang);
            } else {
                response.clinicians = selectedClinicians.map(item => item.name).join(', ');
            }
        }


        return response;
    }


    render() {
        const { groups, clinics, clinicians, dateFrom, dateTo } = this.generateFiltersOptions();

        const selections = this.generateSelectionsText({ groups, clinics, clinicians });

        return (
            <div className='custom-filter-statistics-wrap'>
                <div className='custom-filter-left-statistics'>
                    <div className='custom-filter-top-statistics'>
                        <DatePicker
                            label={'Select period'.translate(this.props.lang)}
                            value={dateFrom}
                            lang={this.props.lang}
                            dateFormat={this.props.dateFormat}
                            onChange={(date) => {
                                if (!date) return;
                                let formattedDate = this.inverseFormatStringDate(date);
                                if (!formattedDate) return;
                                let filter = JSON.parse(JSON.stringify(this.state.filter));
                                filter.range.start = formattedDate;
                                if (new Date(filter.range.start) > new Date(filter.range.end)) {
                                    filter.range.end = formattedDate;
                                }
                                // this.setFilter(filter);
                                this.setState({ _tempRange: filter.range })
                            }}
                        />
                        <DatePicker
                            label={'-'.translate(this.props.lang)}
                            value={dateTo}
                            lang={this.props.lang}
                            dateFormat={this.props.dateFormat}
                            minDate={new Date(dateFrom)}
                            onChange={(date) => {
                                if (!date) return;
                                let formattedDate = this.inverseFormatStringDate(date);
                                if (!formattedDate) return;
                                let filter = JSON.parse(JSON.stringify(this.state.filter));
                                filter.range.end = formattedDate;
                                // this.setFilter(filter);
                                this.setState({ _tempRange: filter.range })
                            }}
                        />

                        <Button
                            color='primary'
                            className='custom-filter-set-filter-btn'
                            style={{ marginLeft: '8px' }}
                            disabled={!this.state._tempRange || (this.state._tempRange?.start === this.state.filter?.range?.start && this.state._tempRange?.end === this.state.filter?.range?.end)}
                            onClick={() => {
                                if (!this.state._tempRange) return;
                                let filter = JSON.parse(JSON.stringify(this.state.filter));
                                filter.range.start = this.state._tempRange.start;
                                filter.range.end = this.state._tempRange.end;
                                this.setFilter(filter);
                            }}
                        >
                            {'Apply'.translate(this.props.lang)}
                        </Button>
                    </div>
                    <div className='custom-filter-bottom-statistics'>
                        <CustomCalendarFilterSelect
                            placeholder={'Clinics'.translate(this.props.lang)}
                            items={groups?.map((item) => {
                                return {
                                    label: item.name,
                                    value: item._id
                                }
                            })}
                            onChange={(values) => {
                                let filter = this.state.filter;
                                filter.groups = values;
                                this.setFilter(filter);
                            }}
                            registerSetData={(setSelectedGroups) => this.setSelectedGroups = setSelectedGroups}
                            lang={this.props.lang}
                            splitValueText={false}
                        />
                        <CustomCalendarFilterSelect
                            placeholder={'Departments'.translate(this.props.lang)}
                            items={clinics?.map((item) => {
                                return {
                                    label: item.name,
                                    value: item._id
                                }
                            })}
                            onChange={(values) => {
                                let filter = this.state.filter;
                                filter.clinics = values;
                                this.setFilter(filter);
                            }}
                            registerSetData={(setSelectedClinics) => this.setSelectedClinics = setSelectedClinics}
                            lang={this.props.lang}
                            splitValueText={false}
                        />
                        <CustomCalendarFilterSelect
                            placeholder={'Clinicians'.translate(this.props.lang)}
                            items={clinicians?.map((item) => {
                                return {
                                    label: item.name,
                                    value: item._id
                                }
                            })}
                            onChange={(values) => {
                                let filter = this.state.filter;
                                filter.clinicians = values;
                                this.setFilter(filter);
                            }}
                            registerSetData={(setSelectedClinicians) => this.setSelectedClinicians = setSelectedClinicians}
                            lang={this.props.lang}
                            splitValueText={true}
                        />
                    </div>
                </div>
                <div className='custom-filter-right-statistics'>
                    <h5>{'Selections'.translate(this.props.lang)}</h5>
                    <div className='custom-filter-selection-item-wrap'>
                        <h6>{'Clinics'.translate(this.props.lang)}:</h6>
                        <h6 className='fw-regular'>{selections?.clinics}</h6>
                    </div>
                    <div className='custom-filter-selection-item-wrap'>
                        <h6>{'Departments'.translate(this.props.lang)}:</h6>
                        <h6 className='fw-regular'>{selections?.departments}</h6>
                    </div>
                    <div className='custom-filter-selection-item-wrap'>
                        <h6>{'Clinicians'.translate(this.props.lang)}:</h6>
                        <h6 className='fw-regular'>{selections?.clinicians}</h6>
                    </div>
                </div>


                {
                    this.state.error ?
                        <ErrorModal
                            lang={this.props.lang}
                            isOpen={this.state.error}
                            toggle={() => this.setState({ error: null })}
                            closeButtonText={'Cancel'.translate(this.props.lang)}
                            zIndex={9999}
                        >
                            {this.state.error}
                        </ErrorModal>
                        :
                        null
                }

            </div>


        )
    }
}

export default CustomFilterStatistics;